import { useEffect } from 'react';
import { useAuth } from './useAuth';

/**
 * Custom hook to apply user type color to Flatpickr calendars
 * This hook automatically sets the global CSS custom property when the component mounts
 * and updates it whenever the user type changes
 */
export const useFlatpickrUserType = () => {
  const { getUserType } = useAuth();
  const currentUserType = getUserType();
  
  const getUserTypeColor = (userType) => {
    const userTypeConfig = {
      'PET_GUARDIAN': '#8548A8', // Purple
      'VETERINARIAN': '#00D4B3', // Cyan
      'SERVICE_PROVIDER': '#D65745', // Orange
      'CLINIC_MODERATOR': '#2A8AD2', // Blue
      'FIRM': '#1B3A6B', // Navy Blue
    };
    return userTypeConfig[userType] || '#8548A8'; // Default to purple
  };
  
  const userTypeColor = getUserTypeColor(currentUserType);
  
  useEffect(() => {
    // Set the global CSS custom property for user type color
    document.documentElement.style.setProperty('--user-type-color', userTypeColor);
    
    // Also apply it to any existing Flatpickr calendars
    const calendars = document.querySelectorAll('.flatpickr-calendar');
    calendars.forEach(calendar => {
      calendar.style.setProperty('--user-type-color', userTypeColor);
    });
    
    // Create a MutationObserver to watch for new Flatpickr calendars being added
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && node.classList && node.classList.contains('flatpickr-calendar')) {
            node.style.setProperty('--user-type-color', userTypeColor);
          }
        });
      });
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    return () => {
      observer.disconnect();
    };
  }, [userTypeColor]);
  
  return userTypeColor;
};
